const convertDollarsToCents = (dollars) => {
  return Math.round(dollars * 100)
}

export default convertDollarsToCents
